import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PhxButtonSelectComponent } from './phx-button-select.component';

import { PhxSelectModule } from '../select/select.module';
import { PhxIconModule } from '../icon/icon.module';
import { PhxTooltipModule } from '../tooltip/phx-tooltip.module';
import { PhxButtonModule } from '../button/phx-button.module';

@NgModule({
  imports: [CommonModule, FormsModule, PhxSelectModule, PhxButtonModule, PhxIconModule, PhxTooltipModule],
  exports: [PhxButtonSelectComponent],
  declarations: [PhxButtonSelectComponent],
})
export class PhxButtonSelectModule {}
